import React, { createContext, useContext, useState } from "react";

const AppContext = createContext();

export const AppProvider = ({ children }) => {
  // Define initial state

  const saved_data = {
    folders: [],
    events: [],
  };
  const initialState = {
    user: null,
    theme: "light",
    dev: false,
    dev_url: "http://127.0.0.1:8000/",
    prod_url: process.env.REACT_APP_API_URL,
    dev_ws: "http://127.0.0.1:8081/",
    prod_ws: process.env.REACT_APP_WS_URL,
    folders_config: null,
    login_security: null,
    planning_config: null,
    saved_data: saved_data,
    // Add other state variables as needed
  };

  // Load the initial state from localStorage or set default values
  const [appState, setAppState] = useState(() => {
    const savedState = localStorage.getItem("appState");
    return initialState;
  });

  // Save appState to localStorage whenever it changes

  // Function to update the prod_url in appState
  const updateProdUrl = (newUrl) => {
    setAppState((prevState) => ({
      ...prevState,
      prod_url: newUrl,
    }));
  };

  // Reset function to restore appState to initial values
  const resetAppState = () => {
    setAppState(initialState);
  };

  return (
    <AppContext.Provider
      value={{
        appState,
        setAppState,
        updateProdUrl,
        resetAppState,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => {
  return useContext(AppContext);
};
